"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormField = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _FormControl = _interopRequireDefault(require("react-bootstrap/lib/FormControl"));
var _formFieldWrapper = require("../form-field-wrapper/form-field-wrapper");
var _excluded = ["id", "label", "valid", "invalid", "helpText", "qaLabel", "showLabel"];
var FormField = exports.FormField = function FormField(_ref) {
  var id = _ref.id,
    label = _ref.label,
    valid = _ref.valid,
    invalid = _ref.invalid,
    helpText = _ref.helpText,
    qaLabel = _ref.qaLabel,
    showLabel = _ref.showLabel,
    formControlProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_formFieldWrapper.FormFieldWrapper, {
    id: id,
    label: label,
    valid: valid,
    invalid: invalid,
    helpText: helpText,
    qaLabel: qaLabel,
    showLabel: showLabel
  }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], formControlProps));
};